import { useTenantStore } from '@sera/core';

// "<tenant> - <title>", or the bare title before tenant config loads.
export function setPageTitle(title: string | undefined): void {
  const tenantName = useTenantStore().config?.tenantName;
  document.title = title
    ? tenantName
      ? `${tenantName} - ${title}`
      : title
    : 'Sera';
}
